import React from "react";
import { Paper } from "@material-ui/core";
import { useEffect } from "react";
import { useState, useRef } from "react";
import { useAlert } from "react-alert";
import { Spinner, Table } from "react-bootstrap";
import ReactToPrint from "react-to-print";
import { baseUrl } from "../../../services/config";
import { upperCase } from "lodash";
import { TheatersSharp } from "@material-ui/icons";
import { useSelector } from "react-redux";
import { DownloadTableExcel } from "react-export-table-to-excel";

const pageStyle = `
  @page {
      margin-left: 1.5in;
    size: legal landscape !important;
}
`;
const pageStyle1 = `
  @page {
    size: A4 !important;
}
`;
const ColumnList = () => {
  const user = useSelector((state) => state.user.user);
  const [campuses, setCampusData] = useState(user.campuses || []);
  const [classesData, setClassesData] = useState([]);
  const [sectionData, setSectionData] = useState([]);
  const [campusName, setCampusName] = useState("");
  const [className, setClassName] = useState("");
  const [sectionName, setSectionName] = useState("");
  const [monthName, setMonthName] = useState("");
  const [monthDays, setMonthDays] = useState([]);
  const [monthYear, setMonthYear] = useState("");
  const [studentsData, setStudentsData] = useState(0);
  const [loading, setloading] = useState(false);
  const [fullSession, setFullSession] = useState({});
  const [yearId, setYearId] = useState("");
  const [sessionData, setSessionData] = useState([]);
  const [educationType, setEducationType] = useState(1);
  const [emptyList, setEmptyList] = useState(false);
  //for print
  const [printloading, setprintloading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");
  const componentRef = useRef(null);
  const exportTable = useRef(null);
  const onBeforeGetContentResolve = React.useRef(null);
  const alert = useAlert();
  let authtoken = localStorage.getItem("userToken");
  const [unitName, setUnitName] = useState("");
  const [icon, setIcon] = useState([]);

  const [campusCourseData, setCampusCourseData] = useState([]);
  const [courseClassData, setCourseClassData] = useState([]);
  const [classSectionData, setClassSectionData] = useState([]);

  const [campusId, setCampusId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [classId, setClassId] = useState("");
  const [sectionId, setSectionId] = useState("");

  useEffect(() => {
    // getAllCampus();
    sessions();
    getSettingData();
  }, []);

  const sessions = () => {
    fetch(`${baseUrl}/session`, {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setSessionData(data.payload);
        data.payload.forEach((session, index) => {
          if (session.active_academic_year == "1") {
            setFullSession(session);
            setYearId(session.id);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllCampus = async () => {
    await fetch(`${baseUrl}/campus`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setCampusData(data.payload);
      })
      .catch((err) => {
        console.log("vehicle", err);
      });
  };

  const getSettingData = async () => {
    await fetch(`${baseUrl}/get-settings`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setUnitName(upperCase(data.payload.settings.unit_name));
        setIcon(data.payload.settings.logo_file);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onCampusChange = (id) => {
    setCampusId(id);
    getCampusCourses(id);
  };

  const getCampusCourses = async (campusId) => {
    setCampusCourseData([]);
    setCourseClassData([]);
    setClassSectionData([]);

    if (campusId == "") {
      return alert.error("Please Select Campus");
    }
    await fetch(`${baseUrl}/campus-all-courses/${campusId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCourseId("");
          setClassId("");
          setCampusCourseData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onCourseChange = (id) => {
    setCourseId(id);
    getCourseClasses(id);
  };

  const getCourseClasses = async (courseId) => {
    setCourseClassData([]);
    setClassSectionData([]);

    if (courseId == "") {
      return alert.error("Please Select Course");
    }
    await fetch(`${baseUrl}/course-all-classes/${courseId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setClassId("");
          setCourseClassData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onClassChange = (id) => {
    setClassId(id);
    getSectionsList(id);
  };

  const getSectionsList = (id) => {
    if (id == "" || campusId == "" || courseId == "") {
      alert.error("Please Select Campus / Course/ Class");
      return;
    }
    fetch(`${baseUrl}/class-section/${campusId}/${courseId}/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setClassSectionData(data.payload);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleShow = () => {
    if (campusId == "") {
      alert.error("Campus is required ");
      return;
    }

    let data = {
      campus_id: campusId,
      course_id: courseId,
      student_class_id: classId,
      global_section_id: sectionId,
      status: 2,
      year_id: yearId,
    };
    setloading(true);

    fetch(`${baseUrl}/student_filter_list`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            if (data.payload.length === 0) {
              alert.error("Match not found");
              setCourseId("");
              setClassId("");
              setSectionId("");
              setStudentsData([]);
              setloading(false);
              return;
            }
            let res = data.payload.sort(
              (a, b) => a.admission_id - b.admission_id
            );
            setStudentsData(res);
            setloading(false);
          }
        })
      )

      .catch((err) => {
        setloading(false);
        console.log(err);
      });
  };

  const handleMonthChnage = (value) => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const date = new Date(value);
    setMonthYear(date.getFullYear());
    const monthDays = new Date(
      date.getFullYear(),
      date.getMonth() + 1,
      0
    ).getDate();
    const monthDaysArray = Array.from(Array(monthDays).keys(), (n) => n + 1);
    setMonthName(monthNames[date.getMonth()]);
    setMonthDays(monthDaysArray);
  };
  //for print
  const handleBeforePrint = React.useCallback(() => {}, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    setprintloading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  const handleAfterPrint = React.useCallback(() => {}, []);
  return (
    <>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div className="row">
          <div className="col-md-3">
            <label>
              <b>Select Session</b> <span style={{ color: "red" }}>*</span>
            </label>
            <div className="d-flex flex-column ">
              <select
                style={{ height: 40 }}
                className="form-select"
                name="year_id"
                value={yearId}
                aria-label="Default select example"
                onChange={(e) => {
                  const selectedObject = sessionData.find(
                    (option) => option.id == e.target.value
                  );
                  setFullSession(selectedObject);
                  setYearId(e.target.value);
                }}
              >
                <option value="">Select Session</option>
                {sessionData &&
                  sessionData.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.year}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Campus </b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              onChange={(e) => onCampusChange(e.target.value)}
              className="form-select"
              style={{ backgroundColor: "white", height: 40 }}
              value={campusId}
              aria-label="Default select example"
            >
              <option value="">Select Campus</option>
              {campuses.map((campus, index) => (
                <option key={index} value={campus.id}>
                  {campus.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Course </b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className="form-select form-control"
              name="course_id"
              value={courseId}
              onChange={(e) => onCourseChange(e.target.value)}
              style={{ backgroundColor: "white", height: 40 }}
              aria-label="Default select example"
            >
              <option value="">Select Course</option>
              {campusCourseData.map((item, index) => (
                <option key={index} value={item.course?.id}>
                  {item.course?.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Class </b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className="form-select form-control"
              name="class_id"
              value={classId}
              onChange={(e) => onClassChange(e.target.value)}
              style={{ backgroundColor: "white", height: 40 }}
              aria-label="Default select example"
            >
              <option value="">Select Class</option>
              {courseClassData.map((item, index) => (
                <option key={index} value={item.class?.id}>
                  {item.class?.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3 mt-3">
            <label>
              <b>Select Section </b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className="form-select form-control"
              name="section_id"
              value={sectionId}
              onChange={(e) => setSectionId(e.target.value)}
              style={{ backgroundColor: "white" }}
              aria-label="Default select example"
            >
              <option value="">Select Section</option>
              {classSectionData.map((item, index) => (
                <option key={index} value={item.section?.id}>
                  {item.section?.name}
                </option>
              ))}
            </select>
          </div>

          <div style={{ height: 40 }} className="col-md-2 mt-12">
            <input type="checkbox" style={{ display: "none" }} />
            <label className="checkbox checkbox-single mt-4">
              <input
                type="checkbox"
                onChange={(e) => setEmptyList(e.target.checked)}
              />
              <span />
              &nbsp;&nbsp;&nbsp;Empty List
            </label>
          </div>
          <div className="col-md-4 mt-12">
            <button className="btn btn-primary" onClick={handleShow}>
              Search
            </button>
            {studentsData?.length > 0 ? (
              <ReactToPrint
                documentTitle={`Attendance Report`}
                onAfterPrint={handleAfterPrint}
                pageStyle={pageStyle}
                onBeforeGetContent={handleOnBeforeGetContent}
                onBeforePrint={handleBeforePrint}
                removeAfterPrint={true}
                trigger={() => (
                  <button
                    disabled={printloading ? true : false}
                    className="btn btn-primary w-25 mx-2"
                  >
                    {printloading ? <span>Printing..</span> : "Print"}
                  </button>
                )}
                content={() => componentRef.current}
              />
            ) : null}

            <DownloadTableExcel
              filename="Student List - 11 Column"
              sheet="Student List - 11 Column"
              currentTableRef={exportTable.current}
            >
              {studentsData?.length > 0 ? (
                <button className="btn btn-primary mx-2">Export</button>
              ) : null}
            </DownloadTableExcel>
          </div>
        </div>

        {loading ? (
          <div className="row justify-content-center">
            <Spinner
              className="text-center"
              variant="info"
              animation="border"
            />
          </div>
        ) : (
          <div>
            {studentsData.length > 0 ? (
              <>
                <div className="row p-3 mt-5">
                  <img
                    // className='col-md-2'
                    style={{ height: 100, width: 110 }}
                    src={icon}
                  />

                  <div className="col-md-8">
                    <h1>{unitName}</h1>
                    <h5>
                      LIST OF STUDENT FOR THE ACADEMIC SESSION{" "}
                      {fullSession.year}
                    </h5>
                    <h6>
                      {campusName} &nbsp; {className} &nbsp; {sectionName}
                    </h6>
                  </div>
                </div>
                <div id="tableboot">
                  <table width={"100%"}>
                    <thead>
                      <tr>
                        <th
                          style={{
                            color: "black",
                            border: "1px solid black",
                            textAlign: "center",
                            width: "5%",
                          }}
                        >
                          SrNo.
                        </th>
                        <th
                          style={{
                            color: "black",
                            border: "1px solid black",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                            width: "10%",
                          }}
                        >
                          Adm-Id
                        </th>
                        <th
                          style={{
                            color: "black",
                            border: "1px solid black",
                            textAlign: "center",
                            width: "15%",
                          }}
                        >
                          Student Name
                        </th>
                        <th
                          style={{
                            color: "black",
                            border: "1px solid black",
                            textAlign: "center",
                            width: "15%",
                          }}
                        >
                          Father Name
                        </th>
                        {emptyList ? (
                          <td
                            style={{
                              width: "350px",
                              color: "black",
                              border: "1px solid black",
                              textAlign: "center",
                            }}
                          >
                            {/* Content for includeFee === "true" */}
                            <b> Remarks</b>
                          </td>
                        ) : (
                          [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 0].map(
                            (day, index) => (
                              <td
                                key={index}
                                style={{
                                  width: "50px",
                                  color: "black",
                                  border: "1px solid black",
                                  textAlign: "center",
                                }}
                              ></td>
                            )
                          )
                        )}
                      </tr>
                    </thead>

                    <tbody>
                      {studentsData.map((item, index) => (
                        <tr id="tbl" key={index}>
                          <td
                            style={{
                              color: "black",
                              border: "1px solid black",
                              textAlign: "center",
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            style={{
                              color: "black",
                              border: "1px solid black",
                              textAlign: "center",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.admission_id}
                          </td>
                          <td
                            style={{
                              width: "235px",
                              color: "black",
                              border: "1px solid black",
                              textAlign: "center",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.name.length > 27
                              ? item.name.slice(0, 27)
                              : item.name}
                          </td>
                          <td
                            style={{
                              width: "235px",
                              color: "black",
                              border: "1px solid black",
                              textAlign: "center",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.father_name.length > 27
                              ? item.father_name.slice(0, 27)
                              : item.father_name}
                          </td>
                          {emptyList ? (
                            <td
                              style={{
                                width: "350px",
                                color: "black",
                                border: "1px solid black",
                                textAlign: "center",
                              }}
                            >
                              {/* Content for includeFee === "true" */}
                            </td>
                          ) : (
                            [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 0].map(
                              (day, index) => (
                                <td
                                  key={index}
                                  style={{
                                    width: "50px",
                                    color: "black",
                                    border: "1px solid black",
                                    textAlign: "center",
                                  }}
                                ></td>
                              )
                            )
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            ) : null}
          </div>
        )}

        {/* ///for print */}
        <div
          ref={componentRef}
          id="printSection"
          className="customTablePrint"
        >
          <div>
            {studentsData.length > 0 ? (
              <>
                <div className="p-3" style={{ display: "flex" }}>
                  <img
                    // className='col-md-2'
                    style={{ height: 110, width: 110 }}
                    src={icon}
                  />

                  <div className="col-md-8">
                    <h1>{unitName}</h1>
                    <h5>
                      LIST OF STUDENT FOR THE ACADEMIC SESSION{" "}
                      {fullSession.year}
                    </h5>
                    <h6>
                      {campusName} &nbsp; {className} &nbsp; {sectionName}
                    </h6>
                  </div>
                </div>
                <div id="tableboot">
                  <table>
                    <thead>
                      <tr>
                        <td
                          style={{
                            color: "black",
                            border: "1px solid black",
                            textAlign: "center",
                          }}
                        >
                          Sr
                        </td>
                        <td
                          style={{
                            color: "black",
                            border: "1px solid black",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Adm-Id
                        </td>
                        <td
                          style={{
                            color: "black",
                            border: "1px solid black",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Student Name
                        </td>
                        <td
                          style={{
                            color: "black",
                            border: "1px solid black",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Father Name
                        </td>
                        {emptyList ? (
                          <td
                            style={{
                              width: "650px",
                              color: "black",
                              border: "1px solid black",
                              textAlign: "center",
                            }}
                          >
                            {/* Content for includeFee === "true" */}
                            Remarks
                          </td>
                        ) : (
                          [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 0].map(
                            (day, index) => (
                              <td
                                key={index}
                                style={{
                                  width: "60px",
                                  color: "black",
                                  border: "1px solid black",
                                  textAlign: "center",
                                }}
                              ></td>
                            )
                          )
                        )}
                      </tr>
                    </thead>

                    <tbody>
                      {studentsData.map((item, index) => (
                        <tr id="tbl" key={index}>
                          <td
                            style={{
                              color: "black",
                              border: "1px solid black",
                              textAlign: "center",
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            style={{
                              color: "black",
                              border: "1px solid black",
                              textAlign: "center",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.admission_id}
                          </td>
                          <td
                            style={{
                              color: "black",
                              width: "255px",
                              border: "1px solid black",
                              textAlign: "left",
                              paddingLeft: "3px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.name.length > 27
                              ? item.name.slice(0, 27)
                              : item.name}
                          </td>
                          <td
                            style={{
                              color: "black",
                              width: "255px",
                              border: "1px solid black",
                              textAlign: "left",
                              paddingLeft: "3px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.father_name.length > 27
                              ? item.father_name.slice(0, 27)
                              : item.father_name}
                          </td>
                          {emptyList ? (
                            <td
                              style={{
                                width: "650px",
                                color: "black",
                                border: "1px solid black",
                                textAlign: "center",
                              }}
                            >
                              {/* Content for includeFee === "true" */}
                            </td>
                          ) : (
                            [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 0].map(
                              (day, index) => (
                                <td
                                  key={index}
                                  style={{
                                    width: "60px",
                                    color: "black",
                                    border: "1px solid black",
                                    textAlign: "center",
                                  }}
                                ></td>
                              )
                            )
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            ) : null}
          </div>
        </div>

        {/* ///for exprot print */}
        <div
          ref={exportTable}
          id="printSection"
          className="customTablePrint"
        >
          <div>
            {studentsData.length > 0 ? (
              <>
                <div className="p-3" style={{ display: "flex" }}>
                  <img
                    // className='col-md-2'
                    style={{ height: 110, width: 110 }}
                    src={icon}
                  />

                  <div className="col-md-8">
                    <h1>{unitName}</h1>
                    <h5>
                      LIST OF STUDENT FOR THE ACADEMIC SESSION{" "}
                      {fullSession.year}
                    </h5>
                    <h6>
                      {campusName} &nbsp; {className} &nbsp; {sectionName}
                    </h6>
                  </div>
                </div>
                <div id="tableboot">
                  <table>
                    <thead>
                      <tr>
                        <td
                          style={{
                            color: "black",
                            border: "1px solid black",
                            textAlign: "center",
                          }}
                        >
                          Sr
                        </td>
                        <td
                          style={{
                            color: "black",
                            border: "1px solid black",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Adm-Id
                        </td>
                        <td
                          style={{
                            color: "black",
                            border: "1px solid black",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Student Name
                        </td>
                        <td
                          style={{
                            color: "black",
                            border: "1px solid black",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Father Name
                        </td>
                        {emptyList ? (
                          <td
                            style={{
                              width: "650px",
                              color: "black",
                              border: "1px solid black",
                              textAlign: "center",
                            }}
                          >
                            {/* Content for includeFee === "true" */}
                            Remarks
                          </td>
                        ) : (
                          [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 0].map(
                            (day, index) => (
                              <td
                                key={index}
                                style={{
                                  width: "60px",
                                  color: "black",
                                  border: "1px solid black",
                                  textAlign: "center",
                                }}
                              ></td>
                            )
                          )
                        )}
                      </tr>
                    </thead>

                    <tbody>
                      {studentsData.map((item, index) => (
                        <tr id="tbl" key={index}>
                          <td
                            style={{
                              color: "black",
                              border: "1px solid black",
                              textAlign: "center",
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            style={{
                              color: "black",
                              border: "1px solid black",
                              textAlign: "center",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.admission_id}
                          </td>
                          <td
                            style={{
                              color: "black",
                              width: "255px",
                              border: "1px solid black",
                              textAlign: "left",
                              paddingLeft: "3px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.name.length > 27
                              ? item.name.slice(0, 27)
                              : item.name}
                          </td>
                          <td
                            style={{
                              color: "black",
                              width: "255px",
                              border: "1px solid black",
                              textAlign: "left",
                              paddingLeft: "3px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.father_name.length > 27
                              ? item.father_name.slice(0, 27)
                              : item.father_name}
                          </td>
                          {emptyList ? (
                            <td
                              style={{
                                width: "650px",
                                color: "black",
                                border: "1px solid black",
                                textAlign: "center",
                              }}
                            >
                              {/* Content for includeFee === "true" */}
                            </td>
                          ) : (
                            [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 0].map(
                              (day, index) => (
                                <td
                                  key={index}
                                  style={{
                                    width: "60px",
                                    color: "black",
                                    border: "1px solid black",
                                    textAlign: "center",
                                  }}
                                ></td>
                              )
                            )
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            ) : null}
          </div>
        </div>
      </Paper>
    </>
  );
};

export default ColumnList;
